import { axiosWithConfig } from '@assembly/config/axios'

export const getAssemblyTemplate = (id: string) => {
    return axiosWithConfig.get(`/dashboard/public/assembly_template/${id}`)
}

export const contactFormAssembly = (id: string, data: any) => {
    return axiosWithConfig.post(`/dashboard/public/assembly-template/${id}/contact`, data)
}